import wave from 'assets/images/svg/waves-long.svg';
import React from 'react';
import { getCompany } from 'helpers/getCompanyVariables';
import { cn } from 'lib/utils';
import propTypes from 'prop-types';
import { isMobileWebView } from 'helpers/mobileWebView';
import NeoSubmissionModal from 'tailwind-components/NeoSubmissionModal/NeoSubmissionModal';
import PageHeader from 'tailwind-components/PageHeader/PageHeader';
import Sidebar from 'tailwind-components/Sidebar/Sidebar';
import useMobile from 'hooks/useMobile';
import OnboardingChecklist from 'tailwind-components/PortalWalkthrough/WalkthroughChecklist';
import TourLoadingOverlay from 'tailwind-components/PortalWalkthrough/TourLoadingOverlay';
import { usePortalWalkthrough } from 'tailwind-components/PortalWalkthrough/PortalWalkthroughContext';

const company = getCompany();
const isOneill = company === 'oneill';

function MainLayout({
  children,
  fullHeader,
  activePage,
  contentOverlay,
  topBanner
}) {
  const { isTourDisabled } = usePortalWalkthrough() || {};
  const isMobileDevice = useMobile();
  const isMobileView = isMobileWebView();
  return (
    <div
      className={cn(
        'h-screen w-screen flex justify-start gap-2.5 p-2.5 relative overflow-hidden',
        'bg-grey-background'
      )}
    >
      <Sidebar activePage={activePage} />
      <div
        className={cn(
          'flex flex-col flex-1 min-h-0 w-full relative p-1 md:px-2.5 overflow-hidden',
          'z-50 max-md:z-30'
        )}
      >
        {contentOverlay}
        {topBanner && !isMobileView && (
          <div className='relative z-[110] shrink-0'>{topBanner}</div>
        )}
        {!isMobileView && (
          <header className='shrink-0'>
            <PageHeader fullHeader={fullHeader} />
          </header>
        )}

        <main
          className={cn(
            'flex-1 min-h-0 rounded-xl relative overflow-y-auto overflow-x-hidden max-w-full z-30',
            // reserves the scrollbar's width whether or not the content actually
            // overflows, so content that grows past the fold (e.g. expanding a
            // table row) never shifts everything left by the scrollbar's width
            '[scrollbar-gutter:stable]',
            !isMobileDevice && 'show-scrollbar'
          )}
        >
          {children}
        </main>
      </div>
      {isOneill && (
        <img
          src={wave}
          alt='wave'
          className='w-full h-96 absolute -bottom-52 left-0 z-10 object-cover'
        />
      )}
      {isOneill && <NeoSubmissionModal />}
      {isOneill && !isTourDisabled && (
        <>
          <TourLoadingOverlay />
          <OnboardingChecklist />
        </>
      )}
    </div>
  );
}

MainLayout.propTypes = {
  children: propTypes.array,
  fullHeader: propTypes.bool,
  activePage: propTypes.string,
  contentOverlay: propTypes.node,
  topBanner: propTypes.node
};

export default MainLayout;
